import { ENV } from '../types/internal';

export const environment: ENV = {
  debug: false,
  git_sha: process.env['GIT_SHA'],
  login_url: 'https://staging-login.presence.com',
  sirius_url:
    process.env['SIRIUS_URL'] || 'https://staging-api.presence.com/sirius/v1',
  apps: {
    auth: 'https://staging-api.presence.com/login',
    kanga: 'https://staging-api.presence.com/kanga',
    library: 'https://staging-library.presence.com',
    room: 'https://staging-room.presence.com',
    gateway: 'https://staging-api.presence.com',
  },
  support_email: 'asksupport@presence.com',
  support_phone: '18444154592',
  pendo_key: '',
  heap_key: '',
  fullstory_key: '',
  sentry_dsn:
    process.env['SENTRY_DSN'] ||
    'https://18e08e9f21eb410ab8ffa171bbfdc169@o7007.ingest.sentry.io/4504803481288704',
  baa_sign_url:
    'https://secure.na2.adobesign.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhALU7FzuS4b4fW4VFk56-7PG8F0bqEaU-dqBpn-S20lRD5e7R-WahGE1r8marlO034*',
  learnupon_url: 'presencedev.learnuponus.com',
  config_cat_sdk: 'DgLbCHEjckGEDa0uS7QeUQ/qk_kfWVfR02ZUx1-WNEmXg',
};
